module.exports = __webpack_public_path__ + "img/symbol_12.754aa004.png";